import { User } from 'src/components/types';
import { createAsyncAction, fetchAction } from 'src/redux/actions';
import urls from 'src/sections/repository/urls';
import { urls as profileUrls } from 'src/urls/profile';

export const LoadPullRequestAuthors = createAsyncAction(
  'pullRequestList/LOAD_AUTHORS'
);

export const ClearFilteredAuthors = 'pullRequestList/CLEAR_FILTERED_AUTHORS';

export const LoadPullRequestAuthor = createAsyncAction(
  'pullRequestList/LOAD_AUTHOR'
);

export const UpdatePreloadedAuthor = 'pullRequestList/UPDATE_AUTHOR';

export const fetchPullRequestAuthors = (
  repoUrl: string,
  status: (string | null)[],
  query: string,
  abortSignal?: AbortSignal
) => {
  return fetchAction(LoadPullRequestAuthors, {
    url: urls.api.internal.pullRequestAuthors(repoUrl, { status, query }),
    data: {
      status,
      query,
    },
    fetchOptions: abortSignal ? { signal: abortSignal } : undefined,
  });
};

export const fetchPullRequestAuthor = (uuid: string) => {
  return fetchAction(LoadPullRequestAuthor, {
    url: profileUrls.api.v20.user(uuid),
  });
};

export const clearFilteredAuthors = () => ({
  type: ClearFilteredAuthors,
});

export const updatePreloadedAuthor = (payload: User | null) => ({
  type: UpdatePreloadedAuthor,
  payload,
});
